import Vue from 'vue';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import keycode from 'keycode';
import { formatTime } from '../utils';
import { events } from './events';
export function createViewModel(params) {
    const { el, repository } = params;
    return new Vue({
        el,
        data: {
            loading: false,
            loaded: false,
            currentTime: 0.0,
            bookmarks: [],
        },
        computed: {
            currentTimeStr: function () {
                return formatTime(this.currentTime);
            },
        },
        methods: {
            formatTime,
            add: function () {
                repository
                    .create(this.currentTime, '')
                    .then(result => {
                    this.bookmarks.push(result);
                    this.bookmarks.sort((a, b) => a.position - b.position);
                    this.edit(result);
                })
                    .catch(handleError);
            },
            edit: function (bookmark) {
                bookmark.form = { comment: bookmark.comment };
                bookmark.state.editing = true;
                this.$nextTick(function () {
                    const input = find(this.$refs.input, (input) => input.dataset.key === bookmark.id);
                    if (input) {
                        input.focus();
                    }
                });
            },
            stopEdit: function (bookmark) {
                bookmark.state.editing = false;
            },
            update: function (bookmark) {
                repository
                    .update(bookmark, bookmark.form.comment)
                    .then(result => {
                    bookmark.comment = result.comment;
                    this.stopEdit(bookmark);
                })
                    .catch(handleError);
            },
            input: function (bookmark, event) {
                // enter
                if (keycode.isEventKey(event, 'enter')) {
                    if (bookmark.comment === bookmark.form.comment) {
                        this.stopEdit(bookmark);
                    }
                    else {
                        this.update(bookmark);
                    }
                }
                // escape
                if (keycode.isEventKey(event, 'escape')) {
                    this.stopEdit(bookmark);
                }
            },
            destroy: function (bookmark) {
                if (bookmark && bookmark.links && bookmark.links.destroy) {
                    bookmark.state.deleting = true;
                    repository
                        .delete(bookmark)
                        .then(() => {
                        const index = findIndex(this.bookmarks, { id: bookmark.id });
                        if (index >= 0) {
                            this.bookmarks.splice(index, 1);
                        }
                    })
                        .catch(handleError);
                }
                else {
                    alert('指定された付箋は削除できません。');
                }
            },
            setCurrentTime: function (t) {
                this.currentTime = parseInt('' + t);
            },
            dispose: function () {
                this.$destroy();
            },
            reload: function () {
                return repository
                    .index()
                    .then(bookmarks => {
                    this.bookmarks.length = 0;
                    bookmarks.forEach(bookmark => {
                        this.bookmarks.push(bookmark);
                    });
                })
                    .catch(handleError);
            },
        },
        created: function () {
            repository
                .on(events.LOAD_START, () => {
                this.loading = true;
            })
                .on(events.LOAD_END, () => {
                this.loading = false;
            });
            this.reload().then(() => {
                this.loaded = true;
            });
        },
    });
}
function handleError(error) {
    console.log('error', error);
    alert(error);
}
